// extracted by mini-css-extract-plugin
module.exports = {"divScrollBar":"IpAOku6OychQt_SY2jPr"};